import React, { useState, useEffect, useContext } from 'react';

import styles from './styles.module.scss';

import Api from '../../api';
import { AdminContext } from '../../context/AdminContext';

// import AppTextAreaCount from '../AppTextAreaCount';
import Select from '../Select';
import HelpBox from '../HelpBox';

import Videokeywords from '../../functions/Videokeywords';
import SimpleFormInput from '../SimpleFormInput';
import TagInput from './tagInput';
// import PlaylistInput from './playlistInput';
import Cookies from 'js-cookie';
import AppFormTextArea from '../AppFormTextArea';
// import SimpleTextArea from '../Editor/Editor';
// import SimpleTextArea from '../SimpleTextArea';
// import Toggle from '../Toggle';
// import AppFormInput from '../AppFormInput';
// import FileUpload from '../FileUpload';
// import Loader from '../Loader';

// import dynamic from 'next/dynamic';
// const SimpleTextArea = dynamic(() => import('../Editor/Editor'), {
//   ssr: false,
// });

const UploadVideoForm = ({
  videoInformation,
  handleChange,
  setPressed,
  setVideoInformation,
  dummyEditorState,
  setDummyEditorState,
  editMode = false,
  content,
}) => {
  const { setPrivateUser, themeColor, correctTypeSrt } =
    useContext(AdminContext);

  const [categoryList, setCategoryList] = useState([]);

  const [ageClass, setAgeClass] = useState([]);
  const [channels, setChannels] = useState([]);
  const [usersAllowComment, setUsersAllowComment] = useState([]);
  const [playlistList, setPlaylistList] = useState([]);
  const [switchChildContent, setSwitchChildContent] = useState(
    videoInformation?.child_content == 0 ? false : true
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [contentNumber, setContentNumber] = useState(
    videoInformation?.content?.length
  );

  console.log('videoInformation====', videoInformation);
  const [allTags, setAllTags] = useState(videoInformation?.keywords?.value);

  const [confirmedPlaylist, setConfirmedPlaylist] = useState([]);

  const array = [];

  useEffect(() => {
    const newId = videoInformation?.channel?.value;
    Api.userProfilePlaylistList({ params: { showAll: true, channelId: newId } })
      .then((res) => {
        const newResponse = res.data.response.map((d) => ({
          ...d,
          checked: false,
        }));

        setPlaylistList(newResponse);
      })
      .catch((err) => {});
    setConfirmedPlaylist([]);
  }, [videoInformation?.channel?.value]);
  useEffect(() => {
    if (videoInformation?.child_content == 0) {
      setSwitchChildContent(false);
    } else {
      setSwitchChildContent(true);
    }
  }, [videoInformation?.child_content]);
  useEffect(() => {
    setAllTags(videoInformation?.keywords?.value);
  }, [videoInformation?.keywords?.value]);
  const onBlurFunction = () => {
    let newtags = [];
    let tg = '';
    setPressed(false);

    tg = Videokeywords(videoInformation?.name?.value);

    if (allTags.length != 0) {
      for (let i = 0; i < allTags.length; i++) {
        for (let j = 0; j < tg.length; j++) {
          if (allTags.includes(tg[j]) == false) {
            newtags = [...allTags, tg[j]];
            setAllTags(newtags);
          }
        }
      }
    } else {
      console.log('tag===', tg);
      setAllTags(tg?.slice(0, 12));
    }
  };

  useEffect(() => {
    findMyPlaylist();
    Api.categoryList()
      .then((res) => {
        setCategoryList(res.data.response);
      })
      .catch((err) => {});
    Api.ageClassList()
      .then((res) => {
        setAgeClass(res.data.response);
      })
      .catch((err) => {});

    Api.statusList({ params: { list: 'videoComment' } })
      .then((res) => {
        setUsersAllowComment(
          res.data.response.map((d) => ({ faName: d?.name, id: d?.id }))
        );
      })
      .catch((err) => {});

    Api.userSwitchChannelList({ params: { start: 0, limit: 1000 } })
      .then((res) => {
        setChannels(res.data.response);
      })
      .catch((err) => {});
  }, []);
  console.log('channels', channels);

  const findMyPlaylist = () => {
    const newId =
      typeof window !== 'undefined' &&
      typeof document !== 'undefined' &&
      Cookies.get('userAuthClipsho');
    Api.userProfilePlaylistList({ params: { showAll: true, channelId: newId } })
      .then((res) => {
        const newResponse = res.data.response.map((d) => ({
          ...d,
          checked: false,
        }));

        setPlaylistList(newResponse);
      })
      .catch((err) => {});
  };
  const toggleChildContent = () => {
    setPressed(false);

    if (switchChildContent == true) {
      setSwitchChildContent(false);
      setVideoInformation({ ...videoInformation, child_content: 0 });
    } else {
      setSwitchChildContent(true);
      setVideoInformation({ ...videoInformation, child_content: 1 });
    }
  };
  const togglePrice = () => {
    setVideoInformation({
      ...videoInformation,
      priceType: !videoInformation?.priceType,
    });
  };
  // useEffect(() => {
  //   setVideoInformation({
  //     ...videoInformation,
  //     priceType: false,
  //   });
  // }, [videoInformation?.channel?.value]);

  console.log('vvvvv', videoInformation);
  useEffect(() => {
    const newvar = [...playlistList];

    videoInformation?.playlists?.value.map((item, index) => {
      const x = playlistList.findIndex((x) => x.id == item);
      const obj = newvar[x];
      newvar[x] = { ...obj, checked: true };

      const dummy = { ...obj, checked: true };
      array[index] = dummy;

      setConfirmedPlaylist([...array]);
    });
  }, [playlistList]);

  useEffect(() => {
    if (
      videoInformation.user_status_id == 1 ||
      videoInformation.user_status_id == 5
    ) {
      setPrivateUser({ ids: [], content: '' });
    }
  }, [videoInformation.user_status_id]);

  useEffect(() => {
    handleChange('playlists', {
      ...videoInformation.playlists,
      value: confirmedPlaylist.map((item) => item.id),
      errorTitle: null,
    });
  }, [confirmedPlaylist]);
  useEffect(() => {
    handleChange('keywords', {
      ...videoInformation.keywords,
      value: allTags,
      errorTitle: null,
    });
  }, [allTags]);

  const renderHelpBox = (name, description, limitNum) => {
    return (
      <HelpBox
        openInfoBox={videoInformation[name]?.helpBox}
        setOpenInfoBox={() => {
          handleChange(name, {
            ...videoInformation[name],

            helpBox: !videoInformation[name].helpBox,
          });
        }}
        text={
          limitNum &&
          ` ${limitNum}/${videoInformation[name]?.value?.length}   |   `
        }
      >
        <div className={`flex flex-col justify-start align-start`}>
          <p className={styles.switchDescription}>{description}</p>
        </div>
      </HelpBox>
    );
  };
  console.log('videoinformation', videoInformation);
  // const [dummyEditorState,setDummyEditorState] = useState(videoInformation?.content?.value)
  useEffect(() => {}, [videoInformation?.content?.value]);
  return (
    <form className={`${styles.formContainer}`} id='uploadForm'>
      <SimpleFormInput
        id='titleInput'
        type='text'
        onBlur={onBlurFunction}
        onChange={(e) =>
          handleChange('name', {
            ...videoInformation.name,
            value: e.target.value,
            errorTitle: null,
          })
        }
        className={styles.inputStyle}
        wraperClassName={`${styles.inputWrapper} `}
        title={content?.titleInput}
        error={
          videoInformation?.name?.errorTitle ? content?.titleError : null
        }
        placeholder={content?.titlePlaceholder}
        value={videoInformation?.name?.value}
      >
        {/* {renderHelpBox(
          'name',
          'لطفا از استفاده از نیم فاصله در عنوان ویدیو خودداری کنید',
          1000
        )} */}
      </SimpleFormInput>
      
      {/* <div className={styles.inputStyle}>
        <Select
          list={categoryList}
          title={' انتخاب دسته‌بندی (اجباری)'}
          fillFormFunction={(id) => {
            handleChange('category', {
              ...videoInformation.category,
              value: id,
              errorTitle: null,
            });
          }}
          error={
            videoInformation?.category?.errorTitle
              ? ' دسته‌بندی را انتخاب کنید'
              : null
          }
          value={videoInformation?.category?.value}
        >
          {renderHelpBox(
            'category',
            'شما می‌توانید دسته‌بندی ویدیوی خود را انتخاب کنید. هر ویدیو تنها می‌تواند یک دسته‌بندی داشته باشد.'
          )}
        </Select>
      </div> */}
      {/* <SimpleTextArea
        title='توضیحات  (اجباری) '
        change={(e) => {
          handleChange('content', {
            ...videoInformation.content,
            value: e,
            errorTitle: null,
          });
        }}
        value={videoInformation?.content?.value}
        className={`w-98 mr-0 `}
        placeholder='توضیحات مربوط به ویدیو را وارد کنید'
        error={
          videoInformation?.content?.errorTitle
            ? 'توضیحات  مربوط به ویدیو را وارد کنید'
            : null
        }
      >
        {renderHelpBox(
          'content',
          'شما می‌توانید اطلاعات بیشتری در مورد ویدیوی خود را در این قسمت وارد نمایید.',
          null
        )}
      </SimpleTextArea> */}
      {/* <SimpleTextArea
        title='توضیحات  (اجباری) '
        setVideoInformation={setVideoInformation}
        value={videoInformation?.content?.value}
        className={`w-[99%] mr-[0%]`}
        placeholder='توضیحات مربوط به ویدیو را وارد کنید'
        error={
          videoInformation?.content?.errorTitle
            ? 'توضیحات  مربوط به ویدیو را وارد کنید'
            : null
        }
        html={videoInformation?.content?.value}
        videoInformation={videoInformation}
        dummyEditorState={dummyEditorState}
        setDummyEditorState={setDummyEditorState}
        editMode={dummyEditorState?.length != 0 ? true : false}
      >
        {renderHelpBox(
          'content',
          'شما می‌توانید اطلاعات بیشتری در مورد ویدیوی خود را در این قسمت وارد نمایید.',
          null
        )}
      </SimpleTextArea> */}

      <div className={`${styles.inputStyle} relative`}>
        <TagInput
          videoInformation={videoInformation}
          allTags={allTags ? allTags : []}
          setAllTags={setAllTags}
          setPressed={setPressed}
          content={content}
        >
          {/* {renderHelpBox(
            'keywords',
            'شما می‌توانید در این قسمت برچسب‌های مناسبی را به ویدیوی خود اضافه نمایید. افزودن برچسب، به دسته‌بندی بهتر ویدیوی شما کمک می‌کند.',
            12
          )} */}
        </TagInput>
      </div>
      <AppFormTextArea
       title={content?.contentInput}
        // placeholder='پیام خود را وارد نمایید ...'
        // inputTitleClass={styles.class_title_email}
        // wraperClassName={styles.parent_input_text_area}
        // inputStyle={
        //   errorContent ? styles.text_area_border_yellow : styles.text_area
        // }
        className={`w-[99%] mr-[0%]`}
        // showError={errorContent}
        placeholder={content?.contentPlaceholder}
        error={
          videoInformation?.content?.errorTitle
            ? content?.contentError
            : null
        }
        // onChange={(e) => {
        //   handleChange('content', e.target.value);
        //   // setErrorContent(false);
        //   // setDummyEditorState(e.target.value)
        // }}
        onChange={(e) => {
          handleChange('content', {
            ...videoInformation.content,
            value: e.target.value,
            errorTitle: null,
          });
        }}
        rows='17'
        value={videoInformation?.content?.value}
      />
      {/* <div className={`${styles.inputStyle}`}>
        <Select
          list={channels}
          title={'کانال'}
          fillFormFunction={(id) => {
            let index = channels?.findIndex((x) => x.id == id);
            handleChange('channel', {
              ...videoInformation.channel,
              value: id,
              errorTitle: null,
              price: channels[index].price,
              priceType: channels[index].priceType,
            });
          }}
          error={true ? null : ' کانال را انتخاب کنید'}
          value={videoInformation?.channel?.value}
        >
          {renderHelpBox(
            'channel',
            'هنگامی که چند کانال می‌سازید، می‌توانید کانال خود را بدون خروج از پروفایلتان تعویض کنید. با انتخاب کانال مورد نظر، به مدیریت آن کانال دسترسی خواهید داشت.'
          )}
        </Select>
      </div> */}
      {/* <div className={`${styles.inputStyle} relative`}>
        <PlaylistInput
          videoInformation={videoInformation}
          playlistList={playlistList}
          setPlaylistList={setPlaylistList}
          confirmedPlaylist={confirmedPlaylist}
          setConfirmedPlaylist={setConfirmedPlaylist}
          setPressed={setPressed}
          extraButtonStyle={styles.buttonStyle}
        >
          {renderHelpBox(
            'playlists',
            'شما می‌توانید ویدیو خود را مستقیما به یکی از فهرست‌های پخش خود اضافه نمایید یا درهمین قسمت یک فهرست پخش ساخته و سپس ویدیوی خود را به آن اضافه نمایید.'
          )}
        </PlaylistInput>
      </div> */}

      {/* <div className={styles.inputStyle}>
        <Select
          list={usersAllowComment}
          title={'ارسال دیدگاه'}
          fillFormFunction={(id) => {
            handleChange('comment', {
              ...videoInformation.comment,
              value: id,
              errorTitle: null,
            });
          }}
          error={true ? null : ' نوع فیلد را انتخاب کنید'}
          value={videoInformation?.comment?.value}
        >
          {renderHelpBox(
            'comment',
            'شما می‌توانید انتخاب کنید که چه کسانی امکان نظردهی به ویدیوی شما را داشته باشند.'
          )}
        </Select>
      </div> */}
      {/* <div className={styles.switchContainer}>
        <div
          className={`flex flex-row justify-between items-center w-full h-auto mb-10px`}
        >
          <div
            className={`${styles.switchTitle} ${
              themeColor != 'white' && 'textWhite'
            }`}
          >
            محتوای مخصوص کودک
          </div>
          <Toggle state={switchChildContent} onClick={toggleChildContent} />
        </div>
      </div> */}
      {/* // // ==========================>buy-channel */}
      {/* {videoInformation?.channel?.priceType && (
        <div className={styles.switchContainer}>
          <div
            className={`flex flex-row justify-between items-center w-full h-auto mb-10px`}
          >
            <div
              className={`${styles.switchTitle} ${
                themeColor != 'white' && 'textWhite'
              }`}
            >
              {' ویدیو رایگان '}
              {videoInformation?.priceType && (
                <span className={styles.price}>
                  {`( قیمت کانال: ${videoInformation?.channel?.price} تومان )`}
                </span>
              )}
            </div>
            <Toggle
              state={!videoInformation?.priceType}
              onClick={togglePrice}
            />
          </div>
        </div>
      )} */}
          {/* // // ==========================>buy-channel */}
      {/* <div className={styles.inputStyle}>
        <Select
          list={ageClass}
          title={'مخاطب'}
          error={true ? null : 'مخاطب کانال را وارد کنید'}
          value={videoInformation?.age?.value}
          fillFormFunction={(id) => {
            handleChange('age', {
              ...videoInformation.age,
              value: id,
              errorTitle: null,
            });
          }}
        >
          {renderHelpBox(
            'age',
            ' شما می‌توانید مخاطب ویدیوی خود را انتخاب کنید.'
          )}
        </Select>
      </div> */}
    </form>
  );
};

export default UploadVideoForm;
